module.exports = ".table-parametro > tbody > tr > td, .table-parametro > tbody > tr > th, .table-parametro > tfoot > tr > td, .table-parametro > tfoot > tr > th, .table-parametro > thead > tr > td, .table-parametro > thead > tr > th {\n    vertical-align: middle !important;\n}\n\n.table-parametro {\n    margin-bottom: 0 !important;\n}\n\n.campo_select {\n    width: 8.666667% !important;\n}\n\n.col-centered {\n    float: none;\n    margin: 0 auto;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/artefato/cadastro-produto-transmissao/cadastro-produto-transmissao.component.css
// module id = ./src/app/artefato/cadastro-produto-transmissao/cadastro-produto-transmissao.component.css
// module chunks = main